import { render, staticRenderFns } from "./SurfStateBox.vue?vue&type=template&id=39c86198&scoped=true"
import script from "./SurfStateBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfStateBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c86198",
  null
  
)

export default component.exports